import * as styles from './variants/formText.module.css';

import { generateClassName } from '@klv/shared/utils/functions';

import type { IFormText } from './types';

const FormText = ({
  className = '',
  variant = 'regular',
  ...props
}: IFormText) => (
  <div {...props} className={generateClassName([styles[variant], className])} />
);

export default FormText;
